import React from 'react'
import './ProfileAuthorCard.css'
import ProfileAuthorDataCard from './ProfileAuthorDataCard'
import ProfileAuthorProfileCard from './ProfileAuthorProfileCard'
import ProfileAuthorActionCard from './profileAuthorActionCard'

function ProfileAuthorCard() {
    return (
        <div className="profileLeft">
            <div className="profileAuthor">
                <ProfileAuthorProfileCard />
            </div>
            <div className="profileAuthorE Data">
                <ProfileAuthorDataCard />
            </div>
            <div className="profileAuthorE Action">
                <ProfileAuthorActionCard />
            </div>
        </div>
    )
}

export default ProfileAuthorCard
